import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import {
  IStockCheckReportPageResponse,
  IStockCheckReportResponse,
} from "../models/stockCheck/IStockCheckReport";
import apiConfig from "../utils/apiConfig";

export default function useStockCheckReports(
  page = 1,
  pageSize = 25,
  stockCheckId?: string,
  componentName = "useStockCheckReports"
) {
  const { get } = useApiHelper(apiConfig(componentName));

  const reports = useQuery({
    queryKey: ["stock-check-reports", page, pageSize],
    queryFn: () =>
      get<IStockCheckReportPageResponse>(`/stockcheck?page=${page}&pageSize=${pageSize}`),
  });

  const report = useQuery({
    queryKey: ["stock-check-reports", stockCheckId],
    queryFn: () => get<IStockCheckReportResponse>(`/stockcheck/${stockCheckId}`),
    enabled: !!stockCheckId,
  });

  return {
    reports,
    report,
  };
}
